import { POSTCODE_REGEX } from "_core/validators/regex";
import postcodes from "../../data/postcodes.json";

export function isPostcode(input: string) {
  return Boolean(input.match(POSTCODE_REGEX));
}

export function isPostcodeSupported(value: string) {
  // https://assets.publishing.service.gov.uk/media/5a81ebbded915d74e6234d42/Appendix_C_ILR_2017_to_2018_v1_Published_28April17.pdf
  // we match against the "out code" which is variable size, but we know the "in code" is the last three characters
  // "IG10 1QE" => "IG10"
  const outCode = value.toUpperCase().trim().slice(0, -3).trim();

  return postcodes.includes(outCode);
}
